import { ValidationPatterns } from '../constants/form';

export const isValidUrl = (urlString: string, allowEmptyUrlString?: boolean) => {
  const trimmedUrl = urlString.trim();

  if (trimmedUrl === '') {
    // If allowEmptyUrlString & link is an empty string or only whitespace, it's valid
    return !!allowEmptyUrlString;
  }

  try {
    const url = new URL(trimmedUrl);
    // Check if the URL has a valid protocol and hostname
    if (!/^https?:$/.test(url.protocol)) {
      throw new Error('Invalid protocol');
    }

    // Ensure the URL matches the valid URL pattern
    if (!ValidationPatterns.url.test(trimmedUrl)) {
      throw new Error('Invalid domain format');
    }
  } catch (error) {
    // If it's not a valid URL object, check if it matches the valid URL pattern
    if (!ValidationPatterns.url.test(trimmedUrl)) {
      return false;
    }
  }

  return true;
};
